import Vue from 'vue'
import VueRouter from 'vue-router'
import LoginPage from '@/views/login/index.vue'
import LayoutPage from '@/views/layout/index.vue'
import DashboardPage from '@/views/dashboard/index.vue'
import RecordsPage from '@/views/records/index.vue'
import UsersPage from '@/views/users/index.vue'
import BannersPage from '@/views/banners/index.vue'
import PosterTemplatesPage from '@/views/poster-templates/index.vue'
import ProjectsPage from '@/views/projects/index.vue'
import BadgesPage from '@/views/badges/index.vue'
import ConfigsPage from '@/views/configs/index.vue'
import AgreementsPage from '@/views/agreements/index.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/login', component: LoginPage },
  {
    path: '/',
    component: LayoutPage,
    redirect: '/dashboard',
    children: [
      { path: 'dashboard', component: DashboardPage },
      { path: 'records', component: RecordsPage },
      { path: 'users', component: UsersPage },
      { path: 'projects', component: ProjectsPage },
      { path: 'badges', component: BadgesPage },
      { path: 'banners', component: BannersPage },
      { path: 'poster-templates', component: PosterTemplatesPage },
      { path: 'poster-templates/:id', component: () => import('@/views/poster-templates/poster-template-editor.vue') },
      { path: 'configs', component: ConfigsPage },
      { path: 'agreements', component: AgreementsPage }
    ]
  }
]

const router = new VueRouter({ routes })

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('admin_token')
  if (to.path !== '/login' && !token) {
    next('/login')
    return
  }
  if (to.path === '/login' && token) {
    next('/dashboard')
    return
  }
  next()
})

export default router
